import { FileTextOutlined } from '@ant-design/icons'
import { Button, Divider } from 'antd'
import { FC } from 'react'

type Props = {
  className?: string
  buttonText?: string
  title?: string
  subtitle?: string
  downloadButtonType: 'default' | 'link' | 'primary'
  downloadTemplateFunction: () => void
  downloadLearnersFunction?: () => void
}

const DownloadTemplateButton: FC<Props> = ({
  className,
  buttonText = 'Download Template',
  title = 'Need a template?',
  subtitle = 'Use our pre-formatted CSV template for quick imports',
  downloadButtonType,
  downloadTemplateFunction,
  downloadLearnersFunction: downloadLearnersFunction
}) => {
  return (
    <div className={`bg-secondary rounded-lg shadow p-4 ${className}`}>
      <div className="flex items-center">
        <div className="flex items-center">
          <FileTextOutlined className="w-6 h-6 mr-3 text-xl font-bold" />
          <div className="min-w-36">
            <p className="font-semibold text-gray-900">{title}</p>
            <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
          </div>
        </div>
        <Button
          className={`ml-auto py-2 px-4 rounded-md  min-h-10 whitespace-normal ${downloadButtonType === 'link' ? 'border-none' : 'border-background'}`}
          onClick={downloadTemplateFunction}
          type={downloadButtonType}
        >
          {buttonText}
        </Button>
      </div>
      {downloadLearnersFunction && (
        <>
          <Divider className="my-3" />
          <p className="text-sm">
            Please{' '}
            <a className="font-medium cursor-pointer" onClick={downloadLearnersFunction}>
              click here
            </a>{' '}
            to download your existing learner list to make updates to them
          </p>
        </>
      )}
    </div>
  )
}

export default DownloadTemplateButton
